import Vue from 'vue';

export default Vue.extend({
    data: function () {
    return {
      data: undefined,
      disable: false,
      butShow: true /** 버튼표시여부 */
    };
  }, 
  watch: {
    'params.colDef.editable': { 
      immediate: true,
      deep: true,
      handler() {
        
        this.$nextTick(() => {
          if(this.params.colDef.editable !== undefined) {
            if(typeof this.params.colDef.editable === 'function'){
              this.disable = !this.params.colDef.editable(this.params)
            }else{
              this.disable = !this.params.colDef.editable
            }
          }
        })
      }
    }
  },
  mounted() {
    this.chkShowButton();
    const param = this.params.colDef.cellRendererParams

    this.data =  param.name
    
    if(this.params.colDef.editable !== undefined) {
      if(typeof this.params.colDef.editable === 'function'){
        this.disable = !this.params.colDef.editable(this.params)
      }else{
        this.disable = !this.params.colDef.editable
      }
    }
  },  
  methods: {
    clickFnc(){
      /** param.onClick 에 명시된 부모 함수 호출 */

      const param = this.params.colDef.cellRendererParams;

      if(param.onClick !== undefined && param.onClick !== '') {
        this.$parent.$parent[param.onClick](this.params.data);
      }
    },
    chkShowButton(){
      /** 버튼표시 유무를 제공되는 함수 파라미터로 판단 : 해당화면에서 특정 로직이 필요하면 별도의 파라미터를 추가하여 구현필요 */
      const param = this.params.colDef.cellRendererParams;
      if(param.showButFlag !== undefined && param.showButFlag !== '') {
        if(param.showButFlag === 'HAPPYCALL_MANAGER'){
          this.butShow = this.params.data.campaignId && this.params.data.campaignId.length>0 ? true : false;
        } else if(param.showButFlag === 'HAPPYCALL_MANAGER2'){
          this.butShow = this.params.data.campaignId && this.params.data.campaignId.length>0 ? false : true;
        }
      }
      
    }
  },
  template: `
    <div>
      <button type='button' class='ag-standard-button' :disabled="disable" v-show="butShow" @click="clickFnc">{{this.data}}</button>
    </div>  
    `,
});